module.exports = __webpack_public_path__ + "img/b_KalciyCS_front.a81aca1e.jpeg";